import { useMutation } from '@northladder/services';

import { ASSET_TRACKER_SERVICE_API } from '../assetTrackerClient';
import { IValidateLoginOtpData } from '../types';

/**
 * Cache key for the login validation mutation.
 * This is used to identify the mutation in the cache.
 */
export const LOGIN_VALIDATE_OTP_MUTATION_KEY =
  'login-validate-otp-mutation-key';

interface IUseValidateLoginOtpMutation {
  onSuccessCallback: (data: IValidateLoginOtpData) => void;
  onErrorCallback?: () => void;
}

/**
 * This performs an API call to validate the email & otp for the user.
 */
export function useValidateLoginOtpMutation({
  onSuccessCallback,
  onErrorCallback,
}: Readonly<IUseValidateLoginOtpMutation>) {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [LOGIN_VALIDATE_OTP_MUTATION_KEY],
    mutationFn: ASSET_TRACKER_SERVICE_API.validateLoginOtp,
    onError: onErrorCallback,
    onSuccess: onSuccessCallback,
  });

  return {
    error,
    isPending,
    validateLoginOtp: mutate,
  };
}
